import {Button, Form, Upload, Input, Modal, Select, notification, Alert} from "antd";
import {MobileOutlined, PlusOutlined, PictureOutlined} from "@ant-design/icons";
import Request from "../../utilis/api/Request";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../utilis/contexts/AuthContext";
import {ChangeAccountTypeValidation} from "../../utilis/tools/validation";
import Urls from "../../utilis/api/Urls";
import Texts from "../../utilis/defaults/Text";
import {RcFile, UploadFile, UploadProps} from "antd/es/upload/interface";
import {getBase64, getMergeImage} from "../../utilis/helpers/imageHelper";
import AuthenticatedForm from "./AuthenticatedForm";
import ValueLabel from "../../utilis/models/valueLabel";
import AppContext from "../../utilis/contexts/AppContext";
import DefaultForm from "./DefaultForm";
import {ConvertPersianToEnglish} from "../../utilis/helpers/convertor";
import Api from "../../utilis/api/service";
import LocalStorage from "../../utilis/tools/LocalStorage";
import ServiceResponseTime from "../../utilis/enums/ServiceResponseTime";
import ResponseMessageHandler from "../../utilis/helpers/ResponseMessage";
import Text from "../../utilis/defaults/Text";
import AbfaLogo from "../../images/logo.png"
import ConfirmInfoModal from "../modals/ConfirmInfoModal";

const ChangeAccountType = () => {
    const {Option} = Select;
    const authContext = useContext(AuthContext);
    const appContext = useContext(AppContext);
    const {globalData} = appContext;
    // @ts-ignore
    const {account_types} = globalData;
    // @ts-ignore
    const token = authContext.authenticated ? null : authContext.data.token;
    // @ts-ignore
    const [data, setData] = useState(authContext.authenticated ? authContext.data : authContext.data.data)
    const [isLoading, setLoading] = useState(false);
    const [currentAccountType, setCurrentAccountType] = useState(data.current_account_type ? data.current_account_type : 1);
    const [newAccountType, setNewAccountType] = useState(0);
    const handlePrint = (text: string, name: string, traceNumber: string, address: string, orderType: string, mobile: string) => {
        // @ts-ignore

        // @ts-ignore
        var newWin = window.open('', '', 'height=650, width=650');
        // @ts-ignore
        newWin.document.write('');
        // @ts-ignore

        // @ts-ignore
        newWin.document.write(`
            <div style="margin-bottom: 4px;display: flex; justify-content: center;font-family:'iranSans';"><h3>اداره آب و فاضلاب مازندران</h3></div>
            <div style="border: 1px solid #5e5d5d;border-radius: 7px">
                        <p style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">${text}
        </p>
     
                <div style="direction:rtl;display: flex;justify-content: start;flex-wrap: wrap;font-family:'iranSans';">
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">نام و نام خانوادگی : ${name}</span>
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">کد رهگیری : ${traceNumber}</span>
                 <span style="padding: 10px;font-family:'iranSans';">نوع درخواست : ${orderType}</span>
                 <span style="padding: 10px;font-family:'iranSans';">موبایل : ${mobile}</span>
                 <span style="padding: 10px;font-family:'iranSans';">آدرس : ${address}</span>
        </div>
            </div>
                   <div style="display: flex;justify-content: center;align-items: center;">
            <img style="width:250px;height: auto;margin-top: 50px; opacity: 80%" src="${AbfaLogo}" alt="">
</div>
        `);
        // @ts-ignore

        // @ts-ignore
        // @ts-ignore
        newWin.document.close();
        // @ts-ignore
        newWin.print();
    }
    const [constructionLicenseList, setConstructionLicenseList] = useState<UploadFile[]>([]);
    const [ImageList, setImageList] = useState<UploadFile[]>([]);
    const [uploadModal, setUploadModal] = useState({
        isOpen: false,
        modalName: '',
        type: '',
    });
    const UploadImageProps: UploadProps = {
        fileList: ImageList,
        onRemove: file => {
            const index = ImageList.indexOf(file);
            const newFileList = ImageList.slice();
            newFileList.splice(index, 1);
            setImageList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            } else {
                setImageList([file]);
            }
            return false;
        },
    };

    const [previewOpen, setPreviewOpen] = useState(false);

    const [constructionLicenseBase64, setConstructionLicenseBase64] = useState('');

    //merge-image
    useEffect(() => {
        getMergeImage(constructionLicenseList, (base64) => {

            setConstructionLicenseBase64(base64)
        })
    }, [constructionLicenseList]);
    const [previewImage, setPreviewImage] = useState('');

    const constructionLicenseProps: UploadProps = {
        fileList: constructionLicenseList,
        onRemove: file => {
            const index = constructionLicenseList.indexOf(file);
            const newFileList = constructionLicenseList.slice();
            newFileList.splice(index, 1);
            setConstructionLicenseList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });
                return false;

            } else {

                getBase64(file).then((base64) => {
                    let newFile: UploadFile = file
                    newFile.thumbUrl = base64;
                    console.log(newFile)

                    setConstructionLicenseList([newFile]);
                    return false
                })


            }


            return false;
        },
    };

    const onPreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };
    const handleCancel = () => setPreviewOpen(false);
    const ShowUploadModal = (modalName: string, type: string) => {

        setUploadModal({
            isOpen: true,
            modalName: modalName,
            type: type
        });
    }
    const handleCancelUploadModal = () => {
        setUploadModal({
            isOpen: false,
            modalName: '',
            type: ''
        });

    };
    const UploadImage = () => {
        const Token = LocalStorage.getToken();
        setLoading(true);


        getMergeImage(ImageList, (imageFile) => {
            let formData = new FormData();
            formData.append("Picture", imageFile);
            formData.append("Cellphone", authContext.user.cellphone);
            formData.append("Type", 'CL');
            Api.post('/UploadPicture', formData, {
                headers: {
                    "Authorization": Token.token_type + " " + Token.access_token,
                    'Content-Type': 'application/json'
                }
            }).then(res => {

            }).catch(e => {

            }).finally(() => {
                setLoading(false)
            })
        })
    }

    const handleSubmit = (values: any) => {
        const body = {
            "Token": token,
            "Cellphone": authContext.authenticated ? authContext.user.cellphone : data.cellphone,
            "NationalCode": authContext.authenticated ? ConvertPersianToEnglish(values.nationalCode) : data.national_code,
            "PostalCode": authContext.authenticated ? ConvertPersianToEnglish(values.postalCode) : data.postal_code,
            "TelNumber": ConvertPersianToEnglish(values.tel),
            "MobileNumber": ConvertPersianToEnglish(values.mobile),
            "FileNumber": authContext.authenticated ? authContext.currentFileNumber : data.file_number,
            "FirstName": data.first_name,
            "LastName": data.last_name,
            "City": authContext.authenticated ? data.city_id : data.city,
            "Email": authContext.authenticated ? values.email : "",
            "Address": values.address ? values.address : data.address,
            "Description": authContext.authenticated ? values.description : data.description,
            "ConstructionLicensePic": constructionLicenseBase64,
            "CurrentAccountType": currentAccountType,
            "NewAccountType": newAccountType
        };
        const newAccountTypeName = account_types.filter((accountType: any) => accountType.value === newAccountType);
        const currenAccountName = account_types.filter((accountType: any) => accountType.value === currentAccountType);
        const modalData = {
            ...body,
            CityName: data.city_name,
            newAccountTypeName: newAccountTypeName.length > 0 ? newAccountTypeName[0].label : '',
            currenAccountName:currenAccountName.length>0? currenAccountName[0].label:''
        }
        Modal.confirm({
            direction: "rtl",
            title: 'آیا از صحت اطلاعات اطمینان دارید؟',
            content: <ConfirmInfoModal
                data={modalData}
                type={"ChangeAccountType"}/>,
            onOk: () => handleRequest(body, values),
            closable: true,
            centered: true,
            okText: "تایید و ارسال",
            cancelText: "بستن",
            width: 800,
        })

    }
    const handleRequest = (body: any, values: any) => {
        setLoading(true)
        Request(Urls.ChangeAccountType, body).then((response: any) => {
            const key = `open${Date.now()}`;

            notification['success']({
                message: response.message,
                description: ResponseMessageHandler(ServiceResponseTime.ChangeAccountType, response.data.trace_number),
                duration: 120,
                key: key,
                btn: <Button type="primary" size="small" onClick={() => {
                    handlePrint(ResponseMessageHandler(ServiceResponseTime.ChangeAccountType, response.data.trace_number), data.first_name + " " + data.last_name, response.data.trace_number, body.Address, Text.ChangeAccountType, values.mobile);

                    notification.destroy()
                }}>
                    چاپ
                </Button>
            });
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })
    }

    const handleAccountType = (value: number) => {
        setNewAccountType(value)
    };

    const onFinishFailed = (error: any) => {

    }
    return <>
        <Form
            name="basic"
            className="w-full flex flex-col"
            layout='vertical'
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            scrollToFirstError={true}
        >

            <AuthenticatedForm validationSchema={ChangeAccountTypeValidation} data={data}/>
            <DefaultForm data={data} validationSchema={ChangeAccountTypeValidation}/>
            <Form.Item label={"نوع کاربری فعلی"}>
                <Select disabled size="large" value={currentAccountType} className="w-full">
                    <>
                        {account_types.map((accountType: ValueLabel) => <Option key={accountType.value}
                                                                                value={accountType.value}>
                            {accountType.label}
                        </Option>)}
                    </>
                </Select>
            </Form.Item>
            <Form.Item label={"نوع کاربری جدید"}>
                <Select size="large" onChange={handleAccountType} className="w-full">
                    <>
                        {account_types.map((accountType: ValueLabel) => <Option key={accountType.value}
                                                                                value={accountType.value}>
                            {accountType.label}
                        </Option>)}
                    </>
                </Select>
            </Form.Item>
            <div className="mt-2 mb-2">
                <Alert className="mb-2 mt-2"
                       message="  کلیه تصاویر ارسالی باید در یکی از فرمت های jpg،tif،tiff،jpeg باشد."
                       type="error"/>
            </div>
            {/*<Form.Item requiredMark="optional"*/}
            {/*           label="تصویر پروانه ساختمانی"*/}
            {/*           name="constructionLicense"*/}
            {/*>*/}
            {/*    <Button onClick={() => ShowUploadModal("تصویر پروانه ساختمانی", "constructionLicense")}>آپلود*/}
            {/*        تصویر</Button>*/}

            {/*</Form.Item>*/}
            <Form.Item requiredMark="optional"
                       label="تصویر پروانه ساختمانی"
                       name="constructionLicense"
            >
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...constructionLicenseProps}>
                    <PictureOutlined/>
                </Upload>

            </Form.Item>

            <Form.Item className="w-full mt-4">
                <Button loading={isLoading} size="large" type="primary" className="bg-primary w-full  md:w-[150px]"
                        htmlType="submit">
                    ثبت درخواست
                </Button>
            </Form.Item>

        </Form>
        <Modal open={previewOpen} title="تصویر" footer={null} onCancel={handleCancel}>
            <img alt="example" style={{width: '100%'}} src={previewImage}/>
        </Modal>
        <Modal open={uploadModal.isOpen} title={uploadModal.modalName} confirmLoading={isLoading} onOk={UploadImage}
               okText="ذخیره و بارگزاری" onCancel={handleCancelUploadModal}>
            <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"}
                    className="flex flex-col justify-center items-center" onPreview={onPreview}
                    listType="picture-card" maxCount={1}  {...UploadImageProps}>
                <PlusOutlined/>

            </Upload>
        </Modal>
    </>
}
export default ChangeAccountType;